import { Head } from "mdx-deck";
import { CodeSurfer, CodeSurferColumns, Step } from "code-surfer";
import { nightOwl, github } from "@code-surfer/themes";
import { Heading, Subheading, KeyBoardShortcuts, Contents, WhatIsCode, NamingThingsInCode, Denesting, CommentsVsDocumentation, ArtCraftEmpathy, End, GithubLink } from "../../../../../../src/components";
import React from 'react';
export default {
  Head: Head,
  CodeSurfer: CodeSurfer,
  CodeSurferColumns: CodeSurferColumns,
  Step: Step,
  nightOwl: nightOwl,
  github: github,
  Heading: Heading,
  Subheading: Subheading,
  KeyBoardShortcuts: KeyBoardShortcuts,
  Contents: Contents,
  WhatIsCode: WhatIsCode,
  NamingThingsInCode: NamingThingsInCode,
  Denesting: Denesting,
  CommentsVsDocumentation: CommentsVsDocumentation,
  ArtCraftEmpathy: ArtCraftEmpathy,
  End: End,
  GithubLink: GithubLink,
  React: React
};